import StatusBadge from "./StatusBadge";
import ResponsavelPopover from "./ResponsavelPopover";
import PrazoBadge from "./PrazoBadge";
import { formatarDataHora } from "../../../utils/solicitacoes/formatters";
import { humanizarEtapa } from "../../../utils/solicitacoes/statusConfig";
import { processoInfo, etapaLabel } from "../../../utils/solicitacoes/processoRegistry";

// `camposExtras`: campos específicos do processo (ex.: Filial, Prioridade) que a página de
// Detalhe já tem via o detalhe do processo — este componente não sabe nada de negócio.
export default function CabecalhoSolicitacao({ solicitacao, camposExtras = [], acoes }) {
    if (!solicitacao) return null;

    const processo = processoInfo(solicitacao.tipoProcesso);
    const etapaTxt = solicitacao.etapaAtual
        ? (etapaLabel(solicitacao.tipoProcesso, solicitacao.etapaAtual) || humanizarEtapa(solicitacao.etapaAtual))
        : "Encerrada";

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6">
            <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
                <div>
                    <div className="flex items-center gap-2 flex-wrap">
                        {processo?.icone && <i className={`${processo.icone} text-primary`} />}
                        <h1 className="font-display text-xl font-bold text-foreground">{solicitacao.numero}</h1>
                        <StatusBadge status={solicitacao.status} />
                    </div>
                    <p className="text-sm text-muted-foreground mt-1">{processo?.label || solicitacao.tipoProcesso}</p>
                </div>
                {acoes}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                <Campo label="Etapa atual" valor={etapaTxt} />
                <Campo label="Solicitante" valor={solicitacao.solicitanteNome} />
                <div className="min-w-0">
                    <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Responsável</span>
                    <ResponsavelPopover solicitacao={solicitacao} />
                </div>
                <Campo label="Criada em" valor={formatarDataHora(solicitacao.dataCriacao)} />
                <Campo label="Última atualização" valor={formatarDataHora(solicitacao.dataAtualizacao)} />
                {solicitacao.dataConclusao && <Campo label="Concluída em" valor={formatarDataHora(solicitacao.dataConclusao)} />}
                {solicitacao.etapaAtual && solicitacao.prazoEtapa && (
                    <div className="min-w-0">
                        <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Prazo da etapa</span>
                        <div className="mt-0.5"><PrazoBadge prazo={solicitacao.prazoEtapa} /></div>
                    </div>
                )}
                {camposExtras.map(c => <Campo key={c.label} label={c.label} valor={c.valor} />)}
            </div>
        </div>
    );
}

function Campo({ label, valor }) {
    return (
        <div className="min-w-0">
            <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">{label}</span>
            <span className="block text-foreground font-medium truncate" title={valor || "-"}>{valor || "-"}</span>
        </div>
    );
}
